import React, { useState } from "react";
import { motion } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const testimonials = [
  {
    name: "Emily Chen",
    role: "Founder, DataSense AI",
    text: "Through this platform, I connected with my technical co-founder and secured our first round of funding. The mentorship program was instrumental in refining our business model.",
    rating: 5,
    image: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    name: "Marcus Johnson",
    role: "Angel Investor",
    text: "As an investor, the quality of startups I’ve discovered here is exceptional. The platform’s vetting process and detailed profiles help me make informed investment decisions.",
    rating: 5,
    image: "https://randomuser.me/api/portraits/men/32.jpg",
  },
  {
    name: "Sarah Williams",
    role: "CTO, EcoSolutions",
    text: "The technical talent we’ve recruited through the platform has been outstanding. The specialized section made it easy to find developers with sustainability experience.",
    rating: 5,
    image: "https://randomuser.me/api/portraits/women/65.jpg",
  },
];

const SuccessStories = () => {
  const [current, setCurrent] = useState(0);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  return (
    <section className="bg-gray-50 py-12 px-4" id="success-stories">
      <div className="max-w-5xl mx-auto text-center"> {/* Reduced width here */}
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-3">
          Success Stories
        </h2>
        <p className="text-gray-600 text-sm md:text-base mb-10">
          Hear from founders and professionals who have achieved their goals through our platform.
        </p>

        <div className="relative overflow-hidden">
          <motion.div
            key={current}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.4 }}
            className="grid sm:grid-cols-1 md:grid-cols-3 gap-4"
          >
            {[0, 1, 2].map((offset) => {
              const index = (current + offset) % testimonials.length;
              const testimonial = testimonials[index];

              return (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-md text-left transition duration-300 ease-in-out"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <h4 className="font-semibold text-sm">{testimonial.name}</h4>
                      <p className="text-xs text-gray-500">{testimonial.role}</p>
                    </div>
                  </div>
                  <div className="flex text-yellow-400 mb-3">
                    {"★".repeat(testimonial.rating)}
                  </div>
                  <p className="text-sm text-gray-700">
                    “{testimonial.text}”
                  </p>
                </div>
              );
            })}
          </motion.div>

          <div className="flex justify-center items-center gap-4 mt-8">
            <button
              onClick={prevSlide}
              className="p-2 rounded-full bg-white shadow hover:bg-gray-100"
            >
              <ChevronLeft className="w-5 h-5 text-gray-600" />
            </button>
            {testimonials.map((_, index) => (
              <div
                key={index}
                className={`w-2 h-2 rounded-full ${
                  current === index ? "bg-blue-600" : "bg-gray-300"
                }`}
              ></div>
            ))}
            <button
              onClick={nextSlide}
              className="p-2 rounded-full bg-white shadow hover:bg-gray-100"
            >
              <ChevronRight className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
